import TabbedSections from "@/components/TabbedSections";
import { sectionsByGroup } from "@/config/sections";

// 대시보드(/dashboard) — "사업이 어떻게 굴러가나"를 보는 지표 화면들(2026-08-10 IA 재편으로
// 관리자와 URL 분리). 탭 구성·순서는 config/sections.jsx 의 dashboard 그룹이 단일 소스다.
// 첫 탭이 "매출·마진 추이"인 이유: 대시보드를 열 때의 첫 질문이 "사업이 잘 되고 있나"라서.
const TABS = sectionsByGroup("dashboard");

export default function DashboardPage() {
  return <TabbedSections tabs={TABS} hideTabs />;
}
